export default __webpack_public_path__ + "static/hero_partnership_mobile_img_2-86a3da579380870155d81a778531a33f.png";